const initialState = {
  data: [],
  imgdata:[],
  updatedata:[],
  countrydata:[],
  docdata:[],
  dataview:[],
  regdata:[],
  headerdata:[],
  };

const Dprofilereducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'FETCH_DATA_SUCCESS':
      return { ...state, data: action.payload };
      case 'FETCH_IMAGE_DATA_SUCCESS':
          return { ...state, imgdata: action.payload };
          case 'FETCH_UPDATE_DATA_SUCCESS':
          return { ...state, updatedata: action.payload };
          case 'FETCH_COUNTRY_DATA_SUCCESS':
          return { ...state, countrydata: action.payload };
          case 'FETCH_DOC_DATA_SUCCESS':
            return { ...state, docdata: action.payload };
            case 'FETCH_VIEW_DATA_SUCCESS':
            return { ...state, dataview: action.payload };
            case 'FETCH_VIEW_DATA__register_SUCCESS':
              return { ...state, regdata: action.payload };


              case 'FETCH_HEADER_DATA':
                return { ...state, headerdata: action.payload };
  
    default:
      return state;
  }
};

export default Dprofilereducer;

